export const current = (state) => state.current;
export const isDark = (state) => state.current === 'dark';
